import React, { useState, useEffect } from "react";
import { useInView } from "react-intersection-observer";

interface FadeInViewProps3 {
  children: React.ReactNode;
  delay?: number; // Optional delay prop
}

export const FadeInView3: React.FC<FadeInViewProps3> = ({
  children,
  delay = 0,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const { ref, inView } = useInView({
    threshold: 0.6,
  });

  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout>;

    if (inView) {
      // Set a delay for fade-in effect
      timeoutId = setTimeout(() => setIsVisible(true), delay);
    } else {
      // Immediately start fade-out when not in view
      // No delay is applied for fade-out to begin immediately
      setIsVisible(false);
    }

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [inView, delay]);

  return (
    <div
      ref={ref}
      style={{
        opacity: isVisible ? 1 : 0,
        transition: `opacity 1s ${delay ? delay + "ms" : "0ms"}`,
      }}
    >
      {children}
    </div>
  );
};
